import React from "react";

const Directions = ({ fill, svgIconSize, styles }) => {
    return (
        <svg
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 426.667 426.667"
            style={{
                enableBackground: "new 0 0 426.667 426.667",
                ...styles,
                width: svgIconSize,
                height: svgIconSize,
            }}
            xmlSpace="preserve"
            fill={fill}
        >
            <g>
                <g>
                    <path
                        d="M420.327,198.24L420.327,198.24l-192-192c-8.32-8.32-21.867-8.32-30.08,0l-192,192c-8.32,8.32-8.32,21.867,0,30.187
           l192,191.893v0.107c8.32,8.32,21.867,8.32,30.187,0l192-192C428.753,220,428.753,206.56,420.327,198.24z M255.953,266.613V213.28
           H170.62v64h-42.667v-85.333c0-11.84,9.493-21.333,21.333-21.333h106.667V117.28l74.667,74.667L255.953,266.613z"
                    />
                </g>
            </g>
        </svg>
    );
};

export default Directions;
